'use client';
import { getProductFamily } from '@cat-ecom/pcc-components/src/components/my-equipment/utils';
import { CatHeading, CatList, CatListItem } from 'components/blocks-components';
import { getFamilyName } from 'services/equipment/utils';
import { Image } from 'components/image';
import { Conditional } from 'components/pcc-components';
import { useTranslations } from 'next-intl';
import { useParams } from 'next/navigation';
import { navigateToSeoUrl } from '../../utils';
import { addEquipmentOnSubmit } from 'services/equipment/actions';
import { listParamsProps, MultiEquipmentListProps } from '../../types';
import styles from './multi-equipment-list.module.scss';
import { useState } from 'react';
import MultiModalPageLoader from '../multi-modal-loaders/multi-modal-page-loader';
import { useRouter } from 'next/navigation';
import { navigateTo } from '@cat-ecom/common/utils/browserUtils';

export const MultiEquipmentList = ({
  list,
  partNumber,
  featureFlags,
  serialNumber
}: Readonly<MultiEquipmentListProps>) => {
  const t = useTranslations();
  // TODO - Input Validation - Ensure that all values used from params are allowed values:
  // lang should always be a two-digit string without numbers or special characters (like 'es');
  // esite should always be a string without numbers or special characters, except for the dash (like demo-dealer).
  const params = useParams();
  const [isLoading, setIsLoading] = useState(false);

  const { push } = useRouter();

  const onClickRedirect = (item) => {
    setIsLoading(true);
    addEquipmentOnSubmit(
      { ...item, serialNumber: serialNumber },
      false,
      '',
      false,
      true
    );
    if (featureFlags.PCC_HEADLESS_ASSET_LANDING_PAGE) {
      push(navigateToSeoUrl(featureFlags, item.seoUrl, params, partNumber));
    } else {
      navigateTo(
        navigateToSeoUrl(featureFlags, item.seoUrl, params, partNumber)
      );
    }
  };
  const getListItems = (lists: listParamsProps[]) => {
    return lists.map((item) => {
      const {
        equipmentFamily,
        imageUrl,
        model,
        name,
        partNumber,
        serialNumber
      } = item;
      const familyName = getFamilyName(model, name);
      const trainCaseEquipmentFamily = getProductFamily(familyName);
      return (
        <CatListItem
          key={partNumber}
          value={`${model} ${trainCaseEquipmentFamily}`}
          onClick={() => onClickRedirect(item)}
          className={styles['cat-list-item']}
        >
          <div className="d-flex">
            <Image
              alt={equipmentFamily}
              width="88"
              height="64"
              src={imageUrl}
              loading="lazy"
              className="m-0 align-top d-inline-block"
            />
            <div
              className={`ms-2 d-inline-block align-content-center text-start`}
            >
              <CatHeading
                variant="display-sm"
                className={styles['model-truncation']}
              >
                {model} {trainCaseEquipmentFamily}
              </CatHeading>

              <Conditional test={!!serialNumber}>
                <CatHeading variant="body">
                  {serialNumber} {t('PREFIX_LABEL')}
                </CatHeading>
              </Conditional>
            </div>
          </div>
        </CatListItem>
      );
    });
  };

  return (
    <>
      <Conditional test={isLoading}>
        <MultiModalPageLoader />
      </Conditional>

      <div className={styles['equipment-list-wrapper']}>
        <CatList data-testid="multi-equipment-list">
          {getListItems(list)}
        </CatList>
      </div>
    </>
  );
};

export default MultiEquipmentList;
